import { createFileRoute } from '@tanstack/react-router';
import { DeveloperMcpSettingsPage } from '../components/settings/developer-mcp-settings.js';

export const Route = createFileRoute('/$workspaceSlug/settings/developer/mcp')({
  component: DeveloperMcpSettingsPage,
});
